.welcome-banner {
  border-radius: 4px;
  border: 1px solid;
  border-color: var(--chart-103-pressed);
  background: var(--white-layout-302-level-1-elevation);

  .text-container {
    padding: 49px calc(var(--spacer) * 3) 10px;
    width: 70%;
  }

  .image-container {
    width: 51%;
    position: relative;
    overflow: hidden;

    svg {
      position: absolute;
      bottom: -48px;
      left: 136px;
      transform: scale(1.42);
      height: 100%;
    }
  }

  .title-container {
    * {
      color: var(--chart-300-icon-buttons);
    }

    #welcome-title-gz-version {
      line-height: 60px;
    }

    #welcome-title {
      line-height: 27px;
    }
  }
}
